import React from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import clsx from 'clsx';
var useTableSortIconStyles = makeStyles(function (theme) { return ({
    sortIcon: {
        '&, &:last-child': {
            marginLeft: theme.spacing(1),
            transform: 'scaleX(0.8)',
            transformOrigin: 'left',
            opacity: 1,
            '& > div': {
                width: 0,
                height: 0,
            },
        },
    },
    arrowUp: {
        border: '0.35em solid transparent',
        borderBottomColor: theme.palette.grey[300],
        marginTop: '-0.175em',
        marginBottom: '0.2em',
    },
    arrowDown: {
        border: '0.35em solid transparent',
        borderTopColor: theme.palette.grey[300],
        marginBottom: '-0.175em',
    },
}); });
var TableSortIcon = function (_a) {
    var muiClass = _a.className;
    var theme = useTheme();
    var classes = useTableSortIconStyles(theme);
    return (React.createElement("div", { className: clsx(muiClass, classes.sortIcon) },
        React.createElement("div", { className: classes.arrowUp, "data-sort-icon": "asc" }),
        React.createElement("div", { className: classes.arrowDown, "data-sort-icon": "desc" })));
};
var MuiTableSortLabel = {
    /* put your new default props here */
    IconComponent: TableSortIcon,
};
export default MuiTableSortLabel;
//# sourceMappingURL=MuiTableSortLabel.js.map